import { render, staticRenderFns } from "./CommonAttachments.vue?vue&type=template&id=32379706"
import script from "./CommonAttachments.vue?vue&type=script&lang=js"
export * from "./CommonAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports